import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Sparkles, Search, Trophy, Crown } from "lucide-react";

const TABS = [
  { to: "/app", label: "Home", icon: Home, id: "home", end: true },
  { to: "/app/routines", label: "Routines", icon: Sparkles, id: "routines" },
  { to: "/app/dupes", label: "Dupes", icon: Search, id: "dupes" },
  { to: "/app/challenges", label: "Challenges", icon: Trophy, id: "challenges" },
  { to: "/app/premium", label: "Premium", icon: Crown, id: "premium" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 max-w-[430px] w-full h-[78px] bg-white/95 backdrop-blur-xl border-t border-border flex justify-around items-center px-2 pb-safe"
      style={{ boxShadow: "0 -8px 32px -8px rgba(46,22,8,0.08)", zIndex: 10000 }}
    >
      {TABS.map(({ to, label, icon: Icon, id, end }) => (
        <NavLink
          key={id}
          to={to}
          end={end}
          data-testid={`tab-${id}`}
          className="flex flex-col items-center gap-1 px-3 py-2 group flex-1"
        >
          {({ isActive }) => (
            <>
              <div
                className={`flex items-center justify-center w-11 h-9 rounded-full transition-all ${
                  isActive ? "bg-rose/10" : ""
                }`}
              >
                <Icon
                  size={22}
                  strokeWidth={1.6}
                  className={isActive ? "text-rose" : "text-cocoa/60"}
                />
              </div>
              <span
                className={`text-[10px] font-medium tracking-wide transition-colors ${
                  isActive ? "text-rose" : "text-cocoa/60"
                }`}
              >
                {label}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
